import React from 'react'

import "./FooterSection.css";
export const FooterSection = () => {
    return (
        <footer className="footer">
            <div className="content has-text-centered">
                <p>
                    <strong> Copyright © Kenny Nguyen 2023 </strong>
                </p>
            </div>
        </footer>
    )
};